import getHelpFileURL from './getHelpFileURL';

export default function getVideoURL(src) {
  if (src.includes('youtube') || src.includes('youtu.be')) return src;
  return getHelpFileURL(src);
}
